import React, { useState } from 'react';
import './App.css';
import graphImage from './graph.png';
import graphImage2 from './graph2.png';

function App() {
  // State variables to hold the selected values
  const [numFormat, setNumFormat] = useState('Binary');
  const [source, setSource] = useState('.csv');
  const [size, setSize] = useState('100');
  const [genSource, setGenSource] = useState('Classic');
  //const [apiResponse, setApiResponse] = useState('');
  const [apiUrl, setApiUrl] = useState(''); // To hold the API URL for debugging
  const [error, setError] = useState(''); // To hold error message
  const [data, setData] = useState(''); // To hold "data" value from API response

  // Handle the Generate button click
  const handleGenerate = async () => {
    // Use the URL API to build the URL safely
    // const url = new URL("http://3.85.165.77:8000/generate");
    const url = new URL("http://api.sqe.io:8000/generate");
    url.searchParams.append("num_format", numFormat.toLowerCase());
    url.searchParams.append("size_value", size);
    url.searchParams.append("size_unit", "B");
    url.searchParams.append("gen_source", genSource.toLowerCase());

    // Set the API URL to state for UI display and debugging
    setApiUrl(url.toString());
    console.log("API being called: ", url.toString());  // Print the API URL to the console for debugging

    try {
      const response = await fetch(url.toString(), {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Check if result exists in the response
      if (data.status === 'success') {
        setData(data.data);  // Populate the textarea with "data" value from API response
      } else {
        setData('No data returned from API');
      }
    } catch (error) {
      console.error('Error:', error);
      setData('Error fetching data');
      setError(error.message); // Log the detailed error message
    }
  };

  // Handle copy to clipboard
  const handleCopy = (elementId) => {
    const copyTarget = document.getElementById(elementId);
    if (copyTarget) {
      navigator.clipboard.writeText(copyTarget.value)
        .then(() => {
          alert("Copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }
  };

  const handleDownload = () => {
    if (!data) {
      alert("No data to download.");
      return;
    }

    const fileType = source === ".csv" ? "csv" : "txt";
    const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `output.${fileType}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="App-container">
      <h1>SQE RNG Dashboard</h1>
      {/* Display API URL for debugging */}
      <div className="api-url-display">
        <h3>API URL:</h3>
        <pre>{apiUrl}</pre>
      </div>
      {/* Display detailed error message */}
      {error && (
        <div className="error-message">
          <h3>Error:</h3>
          <pre>{error}</pre>
        </div>
      )}

      <div className="grid-container">
        {/* Column 1 */}
        <div className="column">
          <h2>Data</h2>
          <div className="input-box-container">   
            <textarea
              className="input-box"
              value={data || "API output will appear here..."}  // Display the "data" from API response or placeholder text
              readOnly
              rows={20}
              id="apiOutput"
            />
            <button className="copy-button" onClick={() => handleCopy("apiOutput")}>Copy</button>
            {/* Text below the Copy button */}
            <p className="copy-note">Powered by SQE Holdings</p>
          </div>
        </div>
        {/* Column 2 */}
        <div className="column">
        <h2>Options</h2>
        <label>
          Number Format:
          <select className="dropdown" value={numFormat} onChange={(e) => setNumFormat(e.target.value)}>
            <option>Binary</option>
            <option>Hex</option>
            <option>Decimal</option>
          </select>
        </label>
        <label>
          Sources:
          <select className="dropdown" value={source} onChange={(e) => setSource(e.target.value)}>
            <option>.csv</option>
            <option>.txt</option>
          </select>
        </label>
        <label>
          Size:
          <select className="dropdown" value={size} onChange={(e) => setSize(e.target.value)}>
            <option>100</option>
            <option>200</option>
            <option>300</option>
          </select>
        </label>
        <label className="dropdown">
          Generator Source:
          <select className="dropdown" value={genSource} onChange={(e) => setGenSource(e.target.value)}>
            <option>Classic</option>
            <option>Quantum</option>
            <option>Simulated Quantum</option>
          </select>
        </label>
        <div className="button-container">
          <button className="analyze-button" onClick={handleGenerate}>Analyze</button>
          <button className="analyze-button" onClick={handleGenerate}>Generate</button>
          <button className="analyze-button" onClick={handleDownload}>Download</button>
        </div>

      {/* Moved Statistics Section */}
      <div className="input-section">
        <h2>Statistics</h2>
        <div className="input-group">
          <div className="input-item">
            <label htmlFor="binSize">Shannon's Entropy:</label>
            <input className="input-box small" type="text" value="H(X)=−∑p(x)log 2 p(x)" readOnly />
          </div>
          <div className="input-item">
            <label htmlFor="color">Z Value:</label>
            <input className="input-box small" type="text" value="x 1 = heads" readOnly />
          </div>
          <div className="input-item">
            <label htmlFor="range">Standard Deviation:</label>
            <input className="input-box small" type="text" value="(2−4.8)x2 = 7.84" readOnly />
          </div>
        </div>
      </div>
      </div>
        {/* Column 3 */}
      <div className="column">
        <h2>Histogram</h2>
        {/* First row: Graph image */}
        <div className="image-row">
          <img src={graphImage} alt="Graph preview" className="graph-image" />
        </div>
        {/* Second row: Another image (same or different) */}
        <h2>Distribution</h2>
        <div className="image-row">
          <img src={graphImage2} alt="Distribution preview" className="graph-image" />
        </div>
    </div>

    </div>
    </div>
  );
}

export default App;
